const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M256,0C114.837,0,0,114.837,0,256s114.837,256,256,256s256-114.837,256-256S397.163,0,256,0z M256,469.333 c-117.632,0-213.333-95.701-213.333-213.333S138.368,42.667,256,42.667S469.333,138.368,469.333,256S373.632,469.333,256,469.333z "
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M250.667,344.96c-13.931,0.235-25.152,11.456-25.387,25.387c-0.021,0.427-0.021,0.875,0,1.301 c0.491,14.016,12.224,24.981,26.24,24.512h-0.853c14.08-0.235,25.387-11.712,25.387-25.813 C275.712,356.459,264.555,345.301,250.667,344.96z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.573,116.693c-30.08-0.896-59.136,10.965-80,32.64c-2.411,3.029-3.691,6.805-3.627,10.667 c0.107,9.451,7.616,17.152,17.067,17.493c4.395,0.021,8.64-1.579,11.947-4.48c13.227-13.717,31.509-21.419,50.56-21.333 c28.8,0,42.667,15.573,42.667,33.92c0,39.253-69.76,44.16-69.76,95.147c0,12.373,7.68,35.2,23.68,35.2c0.128,0,0.277,0,0.427,0 c8.597,0,15.573-6.976,15.573-15.573c0-5.76-4.053-10.667-4.053-16.427c0-38.4,75.093-43.733,76.8-103.253 C336.853,144.427,306.133,116.693,255.573,116.693z"
}))));

const SvgQuestionMark = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question_mark.2dcff2cf.svg";
export { ForwardRef as ReactComponent };